export default function show(el, updateTabIndex = true, addAriaHidden = true, displayValue) {
	if (!el) {
		return;
	}

	el.style.display = typeof displayValue === 'string' && displayValue !== 'none' ? displayValue : 'block';

	if (updateTabIndex) {
		el.removeAttribute('tabindex');
	}
	if (addAriaHidden) {
		el.setAttribute('aria-hidden', false);
	}
}
